import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "quotation-options-modal-body" }
const _hoisted_2 = { class: "modal-bar" }
const _hoisted_3 = { class: "options-container" }
const _hoisted_4 = { class: "option-icon" }
const _hoisted_5 = { class: "templates-section" }
const _hoisted_6 = { class: "templates-list" }
const _hoisted_7 = { class: "template-info" }
const _hoisted_8 = { class: "template-header" }
const _hoisted_9 = { class: "template-text" }
const _hoisted_10 = { class: "template-name" }
const _hoisted_11 = {
  key: 0,
  class: "template-subtitle"
}

import { onMounted, ref } from "vue";
import { useModalStore } from "@/shared/stores/modal";
import { useRouter } from "vue-router";
import AppButtonFlat from "@/shared/components/ui/AppButtonFlat.vue";
import { useSnackbarStore } from "@/shared/stores/snackbar";
import { getQuotationTemplateList } from "@/modules/vendor/services/quotation-templates.api";

type QuotationTemplate = {
  id: string | number;
  name: string;
  subtitle?: string;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'QuotationOptionsModal',
  props: {
    inquiryId: {}
  },
  setup(__props: any) {

const props = __props;

const modal = useModalStore();
const router = useRouter();
const snackbar = useSnackbarStore();

const availableTemplates = ref<QuotationTemplate[]>([]);
const isLoading = ref(false);

async function loadTemplates() {
  if (isLoading.value) return;
  isLoading.value = true;

  try {
    const response = await getQuotationTemplateList();
    const resolved = response?.data ?? response ?? [];
    const rawTemplates = Array.isArray(resolved) ? resolved : resolved?.templates ?? [];

    availableTemplates.value = (rawTemplates as any[]).map((template) => ({
      id: template.id,
      name: template.name ?? template.title ?? "",
      subtitle: template.subtitle ?? template.description ?? "",
    }));
  } catch (error) {
    const message =
      error?.response?.data?.message ||
      error?.response?.data?.error ||
      "Unable to load templates.";
    snackbar.error(message);
  } finally {
    isLoading.value = false;
  }
}

onMounted(loadTemplates);

function handleCreateNew() {
  modal.close();
  router.push({
    name: "vendor.quotation.form",
  });
}

function handleSelectTemplate(template: QuotationTemplate) {
  modal.close();
  router.push({
    name: "vendor.quotation.template.detail",
    params: {
      id: template.id,
    },
    query: {
      inquiryId: String(props.inquiryId ?? ""),
    },
  });
}


return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_AppCard = _resolveComponent("AppCard")!
  const _component_v_card_text = _resolveComponent("v-card-text")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_toolbar, {
      class: "modal-toolbar",
      density: "comfortable",
      flat: ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_v_btn, {
            icon: "",
            variant: "text",
            class: "back-btn",
            "aria-label": "Back",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(modal).close()))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, null, {
                default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                  _createTextVNode("mdi-arrow-left", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          }),
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "modal-title" }, "Create Quotation", -1))
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_v_card_text, { class: "body py-6" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", {
            class: "option-card",
            onClick: handleCreateNew
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_v_icon, { size: "24" }, {
                default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                  _createTextVNode("mdi-plus-circle", -1)
                ]))]),
                _: 1
              })
            ]),
            _cache[5] || (_cache[5] = _createElementVNode("div", { class: "option-content" }, [
              _createElementVNode("h3", { class: "option-title" }, "Create New"),
              _createElementVNode("p", { class: "option-description" }, "Create a custom quotation from scratch")
            ], -1)),
            _createVNode(_component_v_icon, {
              size: "20",
              class: "option-chevron"
            }, {
              default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                _createTextVNode("mdi-chevron-right", -1)
              ]))]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_5, [
            _cache[7] || (_cache[7] = _createElementVNode("h3", { class: "section-title" }, "Available Templates", -1)),
            _createElementVNode("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableTemplates.value, (template) => {
                return (_openBlock(), _createBlock(_component_AppCard, {
                  key: template.id,
                  class: "template-item",
                  onClick: ($event: any) => (handleSelectTemplate(template))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _createVNode(_component_v_icon, {
                          size: "16",
                          class: "template-icon-small"
                        }, {
                          default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                            _createTextVNode("mdi-file-document", -1)
                          ]))]),
                          _: 1
                        }),
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("span", _hoisted_10, _toDisplayString(template.name), 1),
                          (template.subtitle)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(template.subtitle), 1))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ])
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              }), 128))
            ])
          ])
        ])
      ]),
      _: 1
    })
  ]))
}
}

})